import { Outlet } from 'react-router';
import { Layout } from '@/components/Layout';
import { LayoutCard } from '@/components/LayoutCard';

export default function Administration() {
  return (
    <Layout>
      <LayoutCard>
        <Outlet />
      </LayoutCard>
    </Layout>
  );
}
